export enum Carousel {
    workspace = 'workspace',
    listing = 'listing',
    split = 'split',
    fullMap = 'full-map',
}
